import { TextField } from "@mui/material";
import type { GithubIntegrationEntry } from "./GithubIntegrationForm.types";
import { isGithubUrl } from "./GithubIntegrationForm.utils";

interface GithubIntegrationFormProps {
  entry: GithubIntegrationEntry;
  onChange: (entry: GithubIntegrationEntry) => void;
}

export default function GithubIntegrationForm({
  entry,
  onChange,
}: GithubIntegrationFormProps) {
  const patchEntry = (patch: Partial<GithubIntegrationEntry>) =>
    onChange({ ...entry, ...patch });

  const urlValid = isGithubUrl(entry.url);

  return (
    <>
      <p className="m-0 text-sm text-text-secondary">
        Connect a GitHub account or organization with a personal access token.
      </p>
      <TextField
        label="Name"
        placeholder="e.g. definity-app"
        value={entry.name}
        onChange={(e) => patchEntry({ name: e.target.value })}
        fullWidth
        required
        size="small"
      />
      <TextField
        label="GitHub URL"
        placeholder="https://github.com"
        value={entry.url}
        onChange={(e) => patchEntry({ url: e.target.value })}
        error={!!entry.url && !urlValid}
        helperText={
          entry.url && !urlValid
            ? "Must start with https://"
            : "github.com or a GitHub Enterprise host"
        }
        fullWidth
        required
        size="small"
      />
      <TextField
        label="Personal access token"
        type="password"
        value={entry.personal_access_token}
        onChange={(e) => patchEntry({ personal_access_token: e.target.value })}
        fullWidth
        required
        size="small"
      />
    </>
  );
}
